import React from "react";
import PropTypes from "prop-types";
import { ChevronRight } from "lucide-react";
import { cn } from "../utils/classNames";
import { handleInternalLinkClick } from "../utils/navigation";
import { trackEvent } from "../utils/analytics";

// Links a listed show to its published "shows like" page.
const ShowsLikeLink = ({ show, surface, className = "" }) => {
  if (!show?.slug || !show.hasShowsLikePage) {
    return null;
  }

  const href = `/shows-like/${show.slug}`;

  return (
    <a
      href={href}
      onClick={(event) => {
        trackEvent("shows_like_link_click", { surface, show_slug: show.slug });
        handleInternalLinkClick(event, href);
      }}
      className={cn(
        "inline-flex min-h-11 items-center gap-1 text-body-xs text-label-light text-primary underline-offset-2 hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
        className
      )}
    >
      Shows like {show.title}
      <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
    </a>
  );
};

ShowsLikeLink.propTypes = {
  show: PropTypes.shape({
    slug: PropTypes.string,
    title: PropTypes.string,
    hasShowsLikePage: PropTypes.bool,
  }).isRequired,
  surface: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ShowsLikeLink;
